import React, { Component } from 'react';
import Link from 'react-router-dom/Link'
import './servicesidebarblock.css';
import ReactFitText from 'react-fittext';
import has from 'lodash.has';

class Servicesidebarblock extends Component {

    render() {

        const style = has(this, 'props.icon.url') ? { backgroundImage: `url('${this.props.icon.url}')`} : {};
        return (

            <Link className="servicesidebarblock" to={`/dienst/${this.props.slug}`}>
                <div className="servicesidebarblock__icon" style={style} ref="serviceblock" />
                <div className="servicesidebarblock__details">
                    <ReactFitText maxFontSize={26}><div className="servicesidebarblock__title" dangerouslySetInnerHTML={{__html: this.props.title}}/></ReactFitText>
                </div>
            </Link>

        );
    }
}

export default Servicesidebarblock;



// WEBPACK FOOTER //
// ./src/components/servicesidebarblock/servicesidebarblock.js